import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { readAppScreens } from './model';

export function useAppScreens() {
  const authorized = useSelector((state: RootState) => state.session?.authorized);
  const value = useSelector((state: RootState) => state.session?.settings?.app_screens);
  return useMemo(() => readAppScreens(authorized ? value : null), [authorized, value]);
}
